import { isPlatformServer } from '@angular/common';
import { inject, Injectable, PLATFORM_ID } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';

@Injectable({ providedIn: 'root' })
export class IconService {
    matIconRegistry = inject(MatIconRegistry);
    domSanitizer = inject(DomSanitizer);
    platformId = inject(PLATFORM_ID);
    registeredIcons: Set<string> = new Set();

    public registerIcon(name: string, filename: string) {
        if (this.registeredIcons.has(name)) return;
        
        if (isPlatformServer(this.platformId)) {
            /* Register empty icons for server-side-rendering to prevent errors */
            this.matIconRegistry.addSvgIconLiteral(name, this.domSanitizer.bypassSecurityTrustHtml('<svg></svg>'));
        } else {
            this.matIconRegistry.addSvgIcon(name, this.domSanitizer.bypassSecurityTrustResourceUrl(`assets/icons/${filename}.svg`));
        }

        this.registeredIcons.add(name);
    }
}
